var twig = require("twig").twig,
    tokens = [],
    template = twig({"id":"$resolved:b1620729537c4151870d819596dd27273cb55f20f613be6381e34e61000935edb8007c48e98b6e23154d51c30f5511e5eaad991666cdb2591c0cd80b8575552f:magic-tabs.twig","data":[],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;